import {
  GridPinnedColumns,
  GRID_CHECKBOX_SELECTION_COL_DEF,
  GRID_TREE_DATA_GROUPING_FIELD,
} from '@mui/x-data-grid-premium';

export const createPinnedColumnsHandler = (
  originalApplyPinnedColumns: (pinnedColumns: GridPinnedColumns) => void,
  isGroupingEnabled: boolean
) => {
  return (pinnedColumns: GridPinnedColumns) => {
    const protectedColumns = [GRID_CHECKBOX_SELECTION_COL_DEF.field];
    if (isGroupingEnabled) {
      protectedColumns.push(GRID_TREE_DATA_GROUPING_FIELD, 'group_name');
    }

    const userLeftColumns = (pinnedColumns.left || []).filter(
      col => !protectedColumns.includes(col)
    );

    const modifiedPinnedColumns = {
      ...pinnedColumns,
      left: [...protectedColumns, ...userLeftColumns],
    };

    originalApplyPinnedColumns(modifiedPinnedColumns);
  };
};
